import { render, staticRenderFns } from "./CustomContent.vue?vue&type=template&id=555dfa1c"
import script from "./CustomContent.vue?vue&type=script&lang=js"
export * from "./CustomContent.vue?vue&type=script&lang=js"
import style0 from "./CustomContent.vue?vue&type=style&index=0&id=555dfa1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports